import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9rvhvqmmsv: FaireBrandEntity = {
  token: "b_9rvhvqmmsv",
  type: "brand",
  name: "The Moment Collection",
  avatarUrl:
    "https://cdn.faire.com/fastly/5aa9ae4bf7a7a64b3f365479c4fe4300d385e4cdd1abbbae33f6b329da7d5498.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f2128ab1c4b108ad8689f0526a17e47eb790bd7516f57f0138fc5cfa7bdcfe1b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5aa9ae4bf7a7a64b3f365479c4fe4300d385e4cdd1abbbae33f6b329da7d5498.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f2128ab1c4b108ad8689f0526a17e47eb790bd7516f57f0138fc5cfa7bdcfe1b.png",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 180,
  rating: 4.5,
  reviewCount: 226,
  isInsider: true,
  description:
    "Tariff-free.\n\nThe Moment Collection is female-owned, started in 2021, we integrate design, production, sales, and supplies to retailers all over the world. We are committed to creating high-quality, cost-effective products for retailers. When dealing with online sellers, we discovered that they have lost touch when it comes to customer service. We are desirous of treating each customer like our most valuable, to foster an ongoing relationship. \n\n*All products have our brand tag on them, we are not dropshipping and don't do dropshipping. \n*We ship out the orders from our oversea warehouse and the US warehouse within 4-7 days, and it will take another 2-5 days for your order to arrive. \n*Cancellation requests should be made within 24 hours of the order being placed.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.348Z",
    importedBy: "entity-db-cli",
  },
};
